import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["question", "isSkipped", "isCorrect", "hasAnswer", "answer", "label", "index", "submitGradeAnswer", "isPreviewMode", "disabled", "updatedBlankId", "isShowingExplanation", "isSubmissionSubmitted"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo } from 'react';
import { SubmissionScore } from '@module/assignment';
import styled from '@xstyled/styled-components';
import { Space, Input, Tooltip, Row, Col } from 'antd';
import { styleVariables } from '@lib/common';
import { GradingBaseAnswer } from './base-question.component';
import { ScoreInput } from '../score-input';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledAnswerGroup = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledAnswerItem = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  gap: 8px;\n"])));
var StyledAnswerRow = styled(Row)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1;\n  align-items: center;\n"])));
var StyledOrderNumberCol = styled(Col)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n"])));
var StyledOrderNumber = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  min-width: 28px;\n  text-align: center;\n"])));
var StyledAnswerInputCol = styled(Col)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  flex: 1;\n"])));
var StyledAnswerInput = styled(Input)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 5px;\n  border: 1px solid ", ";\n  border-radius: 5px;\n  color: ", ";\n  font-size: 14px;\n  cursor: not-allowed;\n"])), styleVariables.colors.gray10, styleVariables.colors.gray13);
var StyledCorrectAnswerText = styled.label(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  min-width: 80px;\n  flex-shrink: 0;\n  text-align: left;\n  font-weight: ", ";\n  color: ", ";\n"])), styleVariables.font.fontWeightStrong, function (props) {
  if (props.$warning) return styleVariables.colors.gold1;
  if (props.$error) return props.theme.color.fontColorError;
  return props.theme.color.fontColorSuccess;
});
var StyledScoreInputContainer = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  padding: 1px;\n  flex-shrink: 0;\n"])));

var roundNumber = function roundNumber(number) {
  var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var factor = Math.pow(10, decimalPlaces);
  return Math.round(number * factor) / factor;
};

var calculateTotalScore = function calculateTotalScore(answers) {
  var allNotGraded = answers.every(function (blank) {
    return !blank.hasGraded();
  });

  if (allNotGraded) {
    return null;
  }

  return answers.reduce(function (total, answer) {
    if (!answer.hasGraded()) {
      return total;
    }

    return roundNumber(total + answer.score);
  }, 0);
};

var areAllBlanksGraded = function areAllBlanksGraded(answers) {
  return answers.every(function (blank) {
    return blank.score !== SubmissionScore["default"].value;
  });
};

var getScoreInputValue = function getScoreInputValue(score) {
  return score !== SubmissionScore["default"].value ? score : null;
};

export var GradingFillInBlankAnswer = function GradingFillInBlankAnswer(_ref) {
  var question = _ref.question,
      isSkipped = _ref.isSkipped,
      isCorrect = _ref.isCorrect,
      hasAnswer = _ref.hasAnswer,
      fillInBlankGroupAnswer = _ref.answer,
      label = _ref.label,
      index = _ref.index,
      submitGradeAnswer = _ref.submitGradeAnswer,
      isPreviewMode = _ref.isPreviewMode,
      disabled = _ref.disabled,
      updatedBlankId = _ref.updatedBlankId,
      isShowingExplanation = _ref.isShowingExplanation,
      isSubmissionSubmitted = _ref.isSubmissionSubmitted,
      rest = _objectWithoutProperties(_ref, _excluded);

  var totalScore = useMemo(function () {
    return calculateTotalScore(fillInBlankGroupAnswer.answers);
  }, [fillInBlankGroupAnswer.answers]);
  var isAllBlankAnswerGraded = useMemo(function () {
    return areAllBlanksGraded(fillInBlankGroupAnswer.answers);
  }, [fillInBlankGroupAnswer.answers]);

  var renderScoreInput = function renderScoreInput(answerBlank, correctAnswer, submitAnswerScore) {
    var scoreValue = getScoreInputValue(answerBlank.score);
    var isGraded = answerBlank.hasGraded();
    var isDisabled = disabled || updatedBlankId === answerBlank.id.toString();

    var scoreInput = /*#__PURE__*/_jsx(StyledScoreInputContainer, {
      children: /*#__PURE__*/_jsx(ScoreInput, {
        questionScore: correctAnswer.score,
        label: label,
        submitScore: submitAnswerScore,
        value: scoreValue,
        disabled: isPreviewMode || isDisabled,
        active: isGraded,
        danger: isGraded && answerBlank.score === 0
      })
    });

    if (isPreviewMode) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: label.disabledScoreInputText,
        children: scoreInput
      });
    }

    return scoreInput;
  };

  var renderAnswers = function renderAnswers() {
    return question.answers.map(function (answer, index) {
      var _answerBlank$value2;

      var answerBlank = fillInBlankGroupAnswer.answers.find(function (a) {
        return a.answerBlankId === answer.id.toString();
      });
      var correctAnswer = question.correctAnswers.find(function (a) {
        return a.answerId === answer.id.toString();
      });

      if (!answerBlank || !correctAnswer) {
        return null;
      }

      var submitAnswerScore = function submitAnswerScore(score) {
        submitGradeAnswer(score, answerBlank.id.toString());
      };

      var renderAnswerStatus = function renderAnswerStatus() {
        var _answerBlank$value;

        if (!answerBlank.value) {
          if (!isSubmissionSubmitted) {
            return null;
          }

          return /*#__PURE__*/_jsxs(StyledCorrectAnswerText, {
            $error: true,
            children: ["(", label.skipped, ")"]
          });
        }

        var isAnswerBlankCorrect = question.isCorrect(answerBlank.answerBlankId, (_answerBlank$value = answerBlank.value) === null || _answerBlank$value === void 0 ? void 0 : _answerBlank$value.text);
        var isManuallyAwarded = !isAnswerBlankCorrect && answerBlank.hasGraded() && typeof answerBlank.score === 'number' && answerBlank.score > 0;
        return /*#__PURE__*/_jsxs(StyledCorrectAnswerText, {
          $error: !isAnswerBlankCorrect && !isManuallyAwarded,
          $warning: isManuallyAwarded,
          children: ["(", isAnswerBlankCorrect ? label["true"] : label["false"], ")"]
        });
      };

      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsxs(StyledAnswerItem, {
          children: [/*#__PURE__*/_jsxs(StyledAnswerRow, {
            children: [/*#__PURE__*/_jsx(StyledOrderNumberCol, {
              children: /*#__PURE__*/_jsxs(StyledOrderNumber, {
                children: ["(", index + question.index, ")"]
              })
            }), /*#__PURE__*/_jsx(StyledAnswerInputCol, {
              children: /*#__PURE__*/_jsx(StyledAnswerInput, {
                size: "large",
                readOnly: true,
                value: (_answerBlank$value2 = answerBlank.value) === null || _answerBlank$value2 === void 0 ? void 0 : _answerBlank$value2.text
              })
            })]
          }), renderAnswerStatus(), correctAnswer.score && renderScoreInput(answerBlank, correctAnswer, submitAnswerScore)]
        }), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            span: 24,
            children: /*#__PURE__*/_jsxs(StyledCorrectAnswerText, {
              $error: false,
              children: ["(", label.correctAnswers, ": ", answer.description, ")"]
            })
          })
        })]
      }, answer.id.toString());
    });
  };

  return /*#__PURE__*/_jsx(GradingBaseAnswer, _objectSpread(_objectSpread({}, rest), {}, {
    question: question,
    label: label,
    isSkipped: isSkipped,
    isCorrect: isCorrect,
    hasAnswer: hasAnswer,
    submitGradeAnswer: submitGradeAnswer,
    value: totalScore,
    disabled: disabled,
    isAllQuestionAnswersGraded: isAllBlankAnswerGraded,
    isResponderView: isPreviewMode,
    isEssayQuestion: true,
    index: index,
    isShowingExplanation: isShowingExplanation,
    children: /*#__PURE__*/_jsx(StyledAnswerGroup, {
      direction: "vertical",
      size: "middle",
      children: renderAnswers()
    })
  }));
};